import { useEffect } from "react";
import { Color } from "contexts/SnackbarContext/SnackbarContext.jsx";

export const useZoomShortcut = (snackbarContext) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const isPlusKey = e.key === "+" || e.key === "=" || e.key === "±";
      const isMinusKey = e.key === "-" || e.key === "_" || e.key === "—";
      const isAltOrOption = e.altKey;
      const isShift = e.shiftKey;

      const currentValue = localStorage.getItem("zoomEnabled");

      if (isShift && isAltOrOption && isPlusKey) {
        if (currentValue !== "true") {
          localStorage.setItem("zoomEnabled", "true");
          snackbarContext.setNotificationTimeOut(
            Color.success,
            "ZOOM Habilitado!"
          );
        }
        e.preventDefault();
      }

      if (isShift && isAltOrOption && isMinusKey) {
        if (currentValue !== "false") {
          localStorage.setItem("zoomEnabled", "false");
          snackbarContext.setNotificationTimeOut(
            Color.success,
            "ZOOM Desabilitado!"
          );
        }
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [snackbarContext]);
};
